
import { useMemo, useState } from 'react';
import { FLAGS } from 'constants/classifier';
import './style.scss';

const FlagFilter = ({ value = 0, onChange, style }) => {
    const [search, setSearch] = useState('');
    const [open, setOpen] = useState(false);

    const options = useMemo(
        () => Object.entries(FLAGS).map(([label, bit]) => ({ label, bit })),
        [],
    );

    const filtered = options.filter(
        ({ label, bit }) =>
            label.toLowerCase().includes(search.toLowerCase()) &&
            !(value & bit),
    );

    const add = (bit) => {
        onChange(value | bit);
        setSearch('');
    };

    const remove = (bit) => {
        onChange(value & ~bit);
    };

    return (
        <div className="flag-filter" style={style}>
            <div className="flag-select">
                <input
                    value={search}
                    placeholder="Select flags..."
                    onFocus={() => setOpen(true)}
                    onChange={(e) => {
                        setSearch(e.target.value);
                        setOpen(true);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Escape') setOpen(false);
                        if (e.key === 'Enter' && filtered.length) {
                            e.preventDefault();
                            add(filtered[0].bit);
                        }
                    }}
                />

                <span className="arrow">▾</span>

                {open && (
                    <>
                        <div
                            className="backdrop"
                            onClick={() => setOpen(false)}
                        />
                        <div className="menu">
                            {filtered.length ? (
                                filtered.map(({ label, bit }) => (
                                    <button
                                        type="button"
                                        key={bit}
                                        onClick={() => add(bit)}
                                    >
                                        {label}
                                    </button>
                                ))
                            ) : (
                                <div className="empty">
                                    No flags found
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>

            <div className="selected">
                {options
                    .filter(({ bit }) => value & bit)
                    .map(({ label, bit }) => (
                        <span className="chip" key={bit} style={{ color: FLAGS[label] >= 1 << 20 ? '#38b2ac' : '#e53e3e' }}>
                            {label}
                            <button
                                type="button"
                                aria-label={`Remove ${label}`}
                                onClick={() => remove(bit)}
                            >
                                ×
                            </button>
                        </span>
                    ))}
            </div>
        </div>
    );
};

export default FlagFilter;
